<script setup lang="ts">
import Container from './Container/index.vue'
import { useTopicsQuery } from '~~/src/composables/query/topic/useTopicsQuery'
import type { Topic } from '~~/src/types/topic'

const props = defineProps<{
  useAsFilter?: boolean
  isBubbles?: boolean
  activeId?: number
}>()

defineEmits<{
  (event: 'selectTopic', value?: Topic): void
}>()

const { activeId } = toRefs(props)

const filters = useFilters()

const { data, suspense } = useTopicsQuery({
  query: {
    order_by: 'name',
    order_dir: 'asc',
    is_featured: true,
  },
})

const sortedTopics = computed(() => {
  const typeId = filters.value.type_ids?.[0] || 1
  return data.value?.filter(topic => topic.typeIds.includes(typeId)) ?? []
})

await suspense()
</script>

<template>
  <Container
    :topics="sortedTopics"
    :is-bubbles="isBubbles"
    :use-as-filter="useAsFilter"
    :active-id="activeId"
    @select-topic="$emit('selectTopic', $event)"
  />
</template>
